import { Helmet } from "react-helmet-async"
import { useNavigate, useParams } from "../../../../../../../router"
import { FileDetailsLayout } from "../../../../../../../DataDrive"
import useFolderDetailsOutletContext from "../../_folder-details-context"

export default function PricesFilePage() {
	const { fileId } = useParams("/data-drive/folders/:folderId/files/:fileId")
	const { folderDetails, refreshFolderDetails } =
		useFolderDetailsOutletContext()
	const navigate = useNavigate()
	function navigateBackOrToList() {
		return navigate("/data-drive")
	}
	return (
		<>
			<Helmet>
				<title>Data Drive Files</title>
			</Helmet>
			<FileDetailsLayout
				folderDetails={folderDetails}
				refreshFolderDetails={refreshFolderDetails}
				fileId={fileId}
				onSuccess={navigateBackOrToList}
			/>
		</>
	)
}
